import { gsap } from "gsap";

class categoryView {
  init() {
    this.category = document.querySelectorAll(".energy__card");
    this.section = document.querySelector("#energy");
    this.upstreamCard = this.section.querySelector(
      '.energy__card[data-id="upstream"]',
    );
    this.otherCards = this.section.querySelectorAll(
      '.energy__card:not([data-id="upstream"])',
    );

    this.category.forEach((card) => {
      card.addEventListener("mouseenter", () =>
        gsap.to(card, { scale: 1.03, duration: 0.3 }),
      );
      card.addEventListener("mouseleave", () =>
        gsap.to(card, { scale: 1, duration: 0.3 }),
      );
    });
  }

  clickhandler(handler) {
    this.category.forEach((card) => {
      card.addEventListener("click", function () {
        const id = this.dataset.id;
        handler(id);
      });
    });
  }

  show() {
    // Make section visible but transparent initially
    gsap.set(this.section, { autoAlpha: 0, display: "flex" });

    // Get position of the upstream card
    const rect = this.upstreamCard.getBoundingClientRect();
    const fromX = window.innerWidth / 2 - (rect.left + rect.width / 2);
    const fromY = window.innerHeight / 2 - (rect.top + rect.height / 2);

    // Animate
    const tl = gsap.timeline();

    tl.to(this.section, {
      autoAlpha: 1,
      duration: 0.8,
      ease: "power2.inOut",
    });

    // Upstream card fly-in from screen center
    tl.fromTo(
      this.upstreamCard,
      {
        x: fromX,
        y: fromY,
        scale: 1.5,
        opacity: 0,
        zIndex: 10,
      },
      {
        x: 0,
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: "power3.out",
      },
      "-=0.4",
    );

    // Other cards fade in one by one
    tl.from(
      this.otherCards,
      {
        opacity: 0,
        y: 40,
        duration: 0.6,
        stagger: 0.1,
        ease: "power2.out",
      },
      "-=0.2",
    );
  }

  hide() {
    // document.querySelector(".energy").classList.remove("active");
    // gsap.to(this.section, {
    //   autoAlpha: 0,
    //   duration: 0.5,
    //   ease: "power1.inOut",
    //   onComplete: () => gsap.set(this.section, { display: "none" }),
    // });
  }
}

export default new categoryView();
